import styled from "styled-components";

import { theme } from "../../theme/toyotaTheme";
import * as MonthlyPrice from "./MonthlyPrice";
import * as CashPrice from "./CashPrice";

export const Wrapper = styled.div`
    ${MonthlyPrice.PricesWrapper} + ${CashPrice.PricesWrapper} {
        ${CashPrice.Text} {
            display: block;
            color: ${theme.colors.grey7};
        }
    }
`;
